export default __webpack_public_path__ + "static/media/margin-trading.8cd2b4aa.pdf";